
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import classnames from 'classnames'
import WithTooltip from 'components/WithTooltip'

export default class TimeAgo extends React.Component {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    className: PropTypes.string
  }

  render() {
    const {date, className} = this.props
    const tooltip = moment(date).format('YYYY-MM-DD HH:mm')

    return (
      <WithTooltip title={tooltip} style='blue' position='start' align='start'>
        <span className={classnames('time-ago', className)}>
          {distanceInWordsToNow(date)} ago
        </span>
      </WithTooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/TimeAgo/index.js